import React, { FC, useMemo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ProjectEditFrameError } from 'shared/components/error-frames';
import ProjectDisplayLayout from 'shared/components/template/project-display-layout';
import { useProject } from 'shared/hooks/api/useProject';
import { PSImage } from 'shared/pages/project/sections/ps-image';
import styled, { useTheme } from 'styled-components';
import { computeProject } from 'shared/helpers/types/computed/ComputedProject';
import { ImageRequest } from 'shared/constants/imageRequest';
import { API, Project } from '@brg/api';
import { CreateLinkTo } from 'shared/constants/linkTo';
import { PSAuthor } from 'shared/pages/project/sections/ps-author';
import { BTag } from 'core/components';
import { PSTeam } from 'shared/pages/project/sections/ps-team';
import { PSLongread } from 'shared/pages/project/sections/ps-longread';
import { PSBottom } from 'shared/pages/project/sections/ps-bottom';
import { BrowserRouter, useHistory } from 'react-router-dom';
import { bTag, ModalControllerContainer } from 'core';
import StickyActionBar from 'shared/components/stickyActionBar';
import { Title } from 'shared/pages/project/project';

const DivCust = styled.div`
  ::-webkit-scrollbar{
    width: 0;
  }
    overflow-y: scroll;
    margin: 1px auto 0px;
    padding-top: 140px;
    overflow-x: hidden;
    padding-bottom: 156px;
    padding-right: 17px;
    box-sizing: content-box;
    @media (max-width: 960px) {
        padding-bottom: inherit;
    }
`;

interface Prop {
    projectId: string;
}
export const ProjectViewModal: FC<Prop> = ({ projectId }) => {
    const { i18n } = useTranslation();

    const [project, isProjectLoading, projectError] = useProject(projectId, i18n.language, projectId);
    const theme = useTheme();
    const history = useHistory();
    const projectTags = project && project?.tags ? project.tags : [];
    const computedProject = useMemo(() => computeProject(project, ImageRequest.image), [project]);


    useEffect(() => {
        if (projectId) {
            API.fetch('https://api.burgdev.ru/geograffee/api/Project/Get?idProject=' + projectId, {})
                .then((v) => v.json())
                .then((v) => API.toLang<Project[]>(v, i18n.language));
        }
    }, [projectId, i18n]);

    if (projectError) {
        return <ProjectEditFrameError id={projectId} isModalProject/>;
    }

    return (
        <>
            {project && (
                // @ts-ignore
                <BrowserRouter>
                <ModalControllerContainer>
                    <DivCust>
                        <ProjectDisplayLayout
                            project={project}
                            isLoading={isProjectLoading}
                            image={<PSImage project={computedProject}  />}
                            title={
                                <Title
                                    style={{ wordBreak: 'break-word' }}
                                    color={theme.tags.textColor}
                                >
                                    {computedProject.title}
                                </Title>
                            }
                            author={<PSAuthor theme={theme} project={project} />}
                            tags={
                                projectTags.map((v) => (
                                    <BTag
                                        tag={v}
                                        onClick={(e: React.MouseEvent) => {
                                            e.stopPropagation();
                                            history.push(CreateLinkTo.tag(v.tagId));
                                        }}
                                        key={v.tagId}
                                    >
                                        {bTag.title(v)}
                                    </BTag>
                                ))
                            }
                            shouldHideTags
                            team={<PSTeam project={computedProject} raw={project} />}
                            bottom={<PSBottom project={project} />}
                            longread={<PSLongread project={project} />}
                            likesSticker={<StickyActionBar project={project} />}
                        />
                    </DivCust>
                </ModalControllerContainer>
                </BrowserRouter>
            )}
        </>
    );
};
import React, { FC, useMemo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ProjectEditFrameError } from 'shared/components/error-frames';
import ProjectDisplayLayout from 'shared/components/template/project-display-layout';
import { useProject } from 'shared/hooks/api/useProject';
import { PSImage } from 'shared/pages/project/sections/ps-image';
import styled, { useTheme } from 'styled-components';
import { computeProject } from 'shared/helpers/types/computed/ComputedProject';
import { ImageRequest } from 'shared/constants/imageRequest';
import { API, Project } from '@brg/api';
import { CreateLinkTo } from 'shared/constants/linkTo';
import { PSAuthor } from 'shared/pages/project/sections/ps-author';
import { BTag } from 'core/components';
import { PSTeam } from 'shared/pages/project/sections/ps-team';
import { PSLongread } from 'shared/pages/project/sections/ps-longread';
import { PSBottom } from 'shared/pages/project/sections/ps-bottom';
import { BrowserRouter, useHistory } from 'react-router-dom';
import { bTag, ModalControllerContainer } from 'core';
import StickyActionBar from 'shared/components/stickyActionBar';
import { Title } from 'shared/pages/project/project';

const DivCust = styled.div`
  ::-webkit-scrollbar{
    width: 0;
  }
    overflow-y: scroll;
    margin: 1px auto 0px;
    padding-top: 140px;
    overflow-x: hidden;
    padding-bottom: 156px;
    padding-right: 17px;
    box-sizing: content-box;
    @media (max-width: 960px) {
        padding-bottom: inherit;
    }
`;

interface Prop {
    projectId: string;
}
export const ProjectViewModal: FC<Prop> = ({ projectId }) => {
    const { i18n } = useTranslation();

    const [project, isProjectLoading, projectError] = useProject(projectId, i18n.language, projectId);
    const theme = useTheme();
    const history = useHistory();
    const projectTags = project && project?.tags ? project.tags : [];
    const computedProject = useMemo(() => computeProject(project, ImageRequest.image), [project]);


    useEffect(() => {
        if (projectId) {
            API.fetch('https://api.burgdev.ru/geograffee/api/Project/Get?idProject=' + projectId, {})
                .then((v) => v.json())
                .then((v) => API.toLang<Project[]>(v, i18n.language));
        }
    }, [projectId, i18n]);

    if (projectError) {
        return <ProjectEditFrameError id={projectId} isModalProject/>;
    }

    return (
        <>
            {project && (
                // @ts-ignore
                <BrowserRouter>
                <ModalControllerContainer>
                    <DivCust>
                        <ProjectDisplayLayout
                            project={project}
                            isLoading={isProjectLoading}
                            image={<PSImage project={computedProject}  />}
                            title={
                                <Title
                                    style={{ wordBreak: 'break-word' }}
                                    color={theme.tags.textColor}
                                >
                                    {computedProject.title}
                                </Title>
                            }
                            author={<PSAuthor theme={theme} project={project} />}
                            tags={
                                projectTags.map((v) => (
                                    <BTag
                                        tag={v}
                                        onClick={(e: React.MouseEvent) => {
                                            e.stopPropagation();
                                            history.push(CreateLinkTo.tag(v.tagId));
                                        }}
                                        key={v.tagId}
                                    >
                                        {bTag.title(v)}
                                    </BTag>
                                ))
                            }
                            shouldHideTags
                            team={<PSTeam project={computedProject} raw={project} />}
                            bottom={<PSBottom project={project} />}
                            longread={<PSLongread project={project} />}
                            likesSticker={<StickyActionBar project={project} />}
                        />
                    </DivCust>
                </ModalControllerContainer>
                </BrowserRouter>
            )}
        </>
    );
};
